import { render } from "./PremiumSuccess.vue?vue&type=template&id=2e4d257c&scoped=true"
import script from "./PremiumSuccess.vue?vue&type=script&lang=js"
export * from "./PremiumSuccess.vue?vue&type=script&lang=js"

import "./PremiumSuccess.vue?vue&type=style&index=0&id=2e4d257c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4d257c"],['__file',"PremiumSuccess.vue"]])

export default __exports__